import * as React from "react";
import { FaLock, FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";
import colors from "../../styles/colors";
import fontSizes from "../../styles/fontSizes";
import FullEditIcon from "../utils/Icons/FullEditIcon";
import LightEditIcon from "../utils/Icons/LightEditIcon";
import PreviewIcon from "../utils/Icons/PreviewIcon";

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.9rem;
  font-size: ${fontSizes.superAdminButton};
  a {
    text-decoration: none;
    color: inherit;
  }

  .disabled {
    opacity: 0.4;
    background-color: ${colors.grey};
    cursor: default;
  }
`;
const LockIcon = styled.div`
  display: inline-block;
  text-align: center;
  width: 3rem;
  opacity: 0.4;
`;

interface ICourseAccessButtonsProps {
  locked: boolean;
  allowEdit: boolean;
  courseId: string;
}
interface IActionProps {
  available: boolean;
  icon: JSX.Element;
  path: string;
  position: number;
  tooltipProps: {
    "data-for": string;
  };
}
interface IAccessButton {
  available: boolean;
  to: string;
  tooltipProps: {
    "data-for": string;
    "data-place": string;
    "data-tip": string;
  };
}

const AccessLink = styled(Link)`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.regular};
  width: 1em;
  height: 1em;
  margin: 0.2rem;
  padding: 0.5em 1.5em;
  background-color: ${colors.buttonBlue};
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0.5rem rgba(0, 0, 0, 0.25);

  :hover {
    opacity: 0.2;
  }
`;

const AccessButton: React.FC<IAccessButton> = ({ available, children, to, tooltipProps }) => {
  return (
    <AccessLink className={!available ? "disabled" : "custom__button"} to={!available ? "#" : to} {...tooltipProps}>
      {children}
    </AccessLink>
  );
};

export const CourseAccessButtons = (props: ICourseAccessButtonsProps) => {
  const BUTTON_TYPE: Record<string, IActionProps> = {
    Edit: {
      available: props.allowEdit && !props.locked,
      icon: <FullEditIcon />,
      path: `/course-author/${props.courseId}`,
      position: 4,
      tooltipProps: {
        "data-for": props.allowEdit && !props.locked ? "Edit" : "disabledEdit",
      },
    },
    "Light Edit": {
      available: false,
      icon: <LightEditIcon />,
      path: "#",
      position: 3,
      tooltipProps: {
        "data-for": "Light Edit",
      },
    },
    "Preview/Print": {
      available: false,
      icon: <PreviewIcon />,
      path: "#",
      position: 2,
      tooltipProps: {
        "data-for": "Preview/Print",
      },
    },
    Test: {
      available: false,
      icon: <FaPlay color="white" />,
      path: "#",
      position: 1,
      tooltipProps: {
        "data-for": "Test",
      },
    },
  };
  return (
    <ButtonsContainer>
      {props.locked && (
        <LockIcon>
          <FaLock color={colors.grey} />
        </LockIcon>
      )}
      {Object.entries(BUTTON_TYPE)
        .sort(([key, value], [nextKey, nextValue]) => (value.position > nextValue.position ? 1 : -1))
        .map(([key, value]) => {
          const tooltip = {
            ...value.tooltipProps,
            "data-place": "bottom",
            "data-tip": "",
          };
          return (
            <AccessButton
              available={value.available}
              to={value.path}
              children={value.icon}
              tooltipProps={tooltip}
              key={value.position}
            />
          );
        })}
    </ButtonsContainer>
  );
};
